import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const PerformanceAudienceDashboardEmpty: FC = () => {
  const { t } = useTranslation('performanceAudience');

  return (
    <div className='flex flex-col items-center gap-2 rounded-2xl border border-dashed border-secondary-border bg-white p-8 text-center'>
      <h3 className='text-base font-semibold text-slate-900'>{t('empty.title')}</h3>
      <p className='max-w-lg text-sm text-secondary-600'>{t('empty.description')}</p>
    </div>
  );
};
